window.$window = $(window);
window.isSP = false;
window.pageID = $('.l-container').attr('id');

var ScrollMagicObject = require('ScrollMagic');
window.ScrollMagic = ScrollMagicObject.Controller;
window.ScrollScene = ScrollMagicObject.Scene;

require('ScrollMagicPlugin');
require('ScrollMagicDebug');
require('clicktracker');

var CommonController = require('./controller/CommonController');
var IndexController = require('./controller/IndexController');
var PostController = require('./controller/PostController');
var CategoryController = require('./controller/CategoryController');
var PortraitsController = require('./controller/PortraitsController');
var SearchController = require('./controller/SearchController');
var InformationController = require('./controller/InformationController');

new CommonController();
if (pageID === 'top') {
    new IndexController();
}
if (pageID === 'post') {
    new PostController();
}
if (pageID === 'category' || pageID === 'tag') {
    new CategoryController();
}
if (pageID === 'portraits') {
    new PortraitsController();
}
if(pageID === 'search'){
    new SearchController();
}
if(pageID === 'information'){
    new InformationController();
}



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/app.js
 **/